import { sprayService } from "@iso/services";

const actions = {
  FETCH_SPRAY_JOBS: "FETCH_SPRAY_JOBS",
  FETCH_SPRAY_JOBS_SUCCESS: "FETCH_SPRAY_JOBS_SUCCESS",
  FETCH_SPRAY_JOBS_FAILURE: "FETCH_SPRAY_JOBS_FAILURE",

  fetchSprayJobs: (propertyId) => {
    return async (dispatch) => {
      dispatch({ type: actions.FETCH_SPRAY_JOBS });
      try {
        const data = await sprayService.dashboard(propertyId);
        if (data && data.code === "0000") {
          dispatch({
            type: actions.FETCH_SPRAY_JOBS_SUCCESS,
            payload: {
              toBeStarted: data.to_be_started || [],
              prepared: data.prepared || [],
              spraying: data.spraying || [],
              history: data.history || [],
            },
          });
        } else {
          dispatch({
            type: actions.FETCH_SPRAY_JOBS_FAILURE,
            error: "Failed to fetch spray jobs",
          });
        }
      } catch (error) {
        dispatch({
          type: actions.FETCH_SPRAY_JOBS_FAILURE,
          error: error.message,
        });
      }
    };
  },
};

export default actions;
